import type MarkdownIt from 'markdown-it'

/**
 * Wraps CMS tables in a scroll container so a wide table scrolls on its own
 * instead of widening the page. Needs a real wrapper element: making the
 * `<table>` itself the scroll box requires `display: block`, which splits
 * `thead`/`tbody` into separate table boxes and misaligns their columns.
 */
export const markdownItScrollableTables = (md: MarkdownIt) => {
  md.renderer.rules.table_open = (tokens, idx, options, _env, self) =>
    `<div class="markdown-table-scroll">${self.renderToken(tokens, idx, options)}`

  md.renderer.rules.table_close = (tokens, idx, options, _env, self) =>
    `${self.renderToken(tokens, idx, options)}</div>`
}
